$(document).ready(function ()
{
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $.datetimepicker.setLocale('pt');

    $('.toast').toast('show');

    $("#ckeckTools").hide();

    $('.checkAll').on('click', function (e) {
        var table = $(e.target).closest('table');
        $('td input:checkbox', table).prop('checked', this.checked);
        if(this.checked) {
            return $("#ckeckTools").show('fast');
        }
        return $("#ckeckTools").hide('fast');
    });

    $('.sys-checkbox').on('change', function (e) {
        if (groupHasChecked(e)) {
            return $("#ckeckTools").show('fast');
        }
        return $("#ckeckTools").hide('fast');
    });

    function groupHasChecked(e)
    {
        var show = false;
        var tbody = $(e.target).closest('tbody');
        var id = tbody.prop('id');
        $('#' + id + ' > tr > td input:checkbox').each(function(k, checkbox) {
            if(checkbox.checked) {
                show = true;
            }
        });
        return show;
    }

    // ckeckTools ends here
    $(".sys-submitOnChange").on('change', function () {
        this.form.submit();
    });

    // Change CompanyId
    $('#sysCompanyId').on('change', function (e) {
        var companyId = $('#sysCompanyId option:selected').val();
        $('#sysCompanyContainer').hide();
        $('#spinnerCompany').removeClass('d-none');
        $.ajax({
            url: "/ajax/set-company-id",
            type: "get",
            data: {
                companyId: companyId
            },
            success: function () {
                location.reload();
            },
            error: function () {
                alert('Falha ao trocar filial na sessão!');
                location.reload();
            }
        });
    });

    $('#btn-trash').on('click', function () {
        $('#btn-trash').addClass('disabled');
    });

    $('#form-disable-button').submit(function () {
        $(this).find(':input[type=submit]').hide();
        $('#container-btn-submit').append('<div class="spinner-border text-primary"></div>');
    });

    // On click, select the text of input
    $(function () {
        var focusedElement;
        $(document).on('focus', 'input', function () {
            if (focusedElement == this) {
                return; //already focused, return so user can now place cursor at specific point in input.
            }
            if($(this).hasClass("no-select")) {
                return; // Não selecione o texto
            }
            focusedElement = this;
            setTimeout(function () {
                focusedElement.select();
            }, 50); //select all text in any field on focus for easy re-entry. Delay sightly to allow focus to "stick" before selecting.
        });
    });

    $(function () {
        $('[data-toggle="popover"]').popover();
    });

    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    });

    // Print
    $('#btn-print').on('click', function () {
        var copias = $(this).val();
        print(copias);
    });

    $('.sysBtnPrint').on('click', function() {
        var copias = $(this).data('copies');
        var selected = $(this).data('selected');
        hideRowsToPrint(selected);
        print(copias);
    });

    function hideRowsToPrint(selected)
    {
        $('#tbody-print tr').each(function ()
        {
            var check = $(this).find('input[type=checkbox]').prop('checked');
            var id = $(this).find('input[type=checkbox]').prop('id');

            if(selected == 2) {
                return;
            }
            if(selected == 1 && check == true) {
                return;
            }
            if(selected == 0 && check == false) {
                return;
            }

            $('#tr-' + id).css('display','none');
        });
    }

    $('#sidebarCollapse').on('click', function () {
        $('.sidebar').toggleClass('active');
    });

    ajustWindow();
});

$(document).on("click", ".sysDelete", function (event) {
    // Remove tr se o button/link clicado estiver na linha da tabela e conter a class .sysDelete
    $(this).closest("tr").remove();
});

function ajustWindow()
{
    var topbarHeight = $('#topbar').height();
    $('#wrapper').css('padding-top', parseInt(topbarHeight) + parseInt(10));
}

function showRowsToPrint()
{
    $('#tbody-print tr').each(function ()
    {
        var id = $(this).find('input[type=checkbox]').prop('id');
        $('#tr-' + id).css('display','table-row');
    });
}

function print(copias = 1)
{
    var toPrint = document.getElementById('container-print');
    var newWin = window.open('', 'Print-Window');
    newWin.document.open();
    newWin.document.write('<!doctype html><html><link rel="stylesheet" href="https://fox.app.br/css/app.css?v=1.10"><body onload="window.print()"><div class="container-fluid">');
    for(var i=0; i<copias; i++) {
        newWin.document.write(toPrint.innerHTML);
        if(i < copias) {
            newWin.document.write('<div style="page-break-after:always;"></div>');
        }
    }
    newWin.document.write('</div></body></html>');
    newWin.document.close();
    setTimeout(function () {
        newWin.close();
        showRowsToPrint();
    }, 5000);
}

function toggleFullScreen() {
    if ((document.fullScreenElement && document.fullScreenElement !== null) ||
        (!document.mozFullScreen && !document.webkitIsFullScreen)) {
        if (document.documentElement.requestFullScreen) {
            document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
            document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        }
    } else {
        if (document.cancelFullScreen) {
            document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
        }
    }
}
